export default __webpack_public_path__ + "static/media/akmal_shahzad.730dc19f.png";